import CreateResponsiveStyle from '../utils/responsiveStyle';
import {GlobalVariables} from '../utils/globalVariables';
import { Platform, useWindowDimensions } from 'react-native';
export const BillingHomeStyles = () =>{
  const layout = useWindowDimensions();
  const style = CreateResponsiveStyle({
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      paddingTop: 40,
      paddingBottom: 60,
      paddingLeft: 15,
      paddingRight: 15,
      position: 'relative',
    },
    title: {
      color: '#FF5800',
      marginBottom: 20,
      fontWeight: '700',
      textAlign: 'center',
      maxWidth: 610,
      fontSize: 34,
      lineHeight: 35,
      fontFamily: '"Helvetica Neue LT Std 75 Bold", sans-serif',
    },
    subtitle: {
      maxWidth: 725,
      textAlign: 'center',
      fontWeight: '400',
      color: GlobalVariables.colors.primary.darkGrey,
      fontSize: 16,
      fontFamily: '"Helvetica Neue LT Std Roman", sans-serif',
      lineHeight: 23,
    },
    subtitleDownload:{
      fontSize: 26,
      maxWidth: 500,
      lineHeight: 36,
    },
    containterSteps: {
      marginTop: 30,
      marginBottom: 25,
    },
    groupStep: {
    },
    itemGroupStep: {
      width: 385,
      marginTop: 30,
      flexDirection: 'row',
      alignItems: 'flex-end',
    },
    iconItemGroupStep: {
      marginRight: 10,
      marginBottom: 15,
    },
    inputComponent: {
      width: '80%',
    },
    containerButtons: {
      marginTop: 35,
      width: '95%',
      flexDirection: 'row',
      justifyContent: 'space-evenly',
    },
    inputExtraLarge: {
      width: 580,
    },
    inputExtraSmall: {
      width: 150,
    },
    inputGroup:{
    },
    groupLada:{
      width: 'auto',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    groupColonia:{
      width: 'auto',
    },
    lada:{
      width: '100%',
    },
    telefono:{
      width: '100%',
      flex: 1,
    },
    iconConfirmCircle:{
      width: 80,
      height: 80,
    },
    actionsDownload: {
      flexDirection: 'row',
      marginTop: 45,
      height: 200,
    },
    actionsLeftDownload:{
      marginRight: 40 ,
    },
    iconCard:{
      width: 68,
    },
    buttons:{
      width: 160,
    },
    buttonDownload:{
      width: 200,
    },
    pressableQuestion:{
      marginLeft: 10,
      marginBottom: 10,
      ...Platform.select({
        web:{
          cursor: 'pointer',
        },
      }),
    },
    imageHelp:{
      width: 670,
      height: 473,
    },
    modal:{
      width: '100%',
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: GlobalVariables.colors.primary.modal,
    },
    modalContent:{
      backgroundColor: GlobalVariables.colors.secondary.white,
      paddingBottom: 20,
      borderRadius: 25,
    },
    pressableModalContent:{
      width: 50,
      height: 50,
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: 5,
      marginBottom: 5,
      marginLeft: 'auto',
      marginRight: 10,
    },
    columnReverse:{
    },
    errorPersonales:{
      position: 'absolute',
      top: 0,
//amr      backgroundColor: '#A90303',
      backgroundColor: '#46a8f1',
      width: '100%',
      flexDirection: 'row',
      alignItems: 'center',
      height: 55,
      justifyContent: 'center',
    },
    errorPersonalesText:{
      fontSize: 16,
      fontFamily: '"Helvetica Neue LT Std Roman", sans-serif',
      color: GlobalVariables.colors.secondary.white,
      marginLeft: 10,
    },
    legend:{
      marginTop: 20,
      fontSize: 16,
      fontFamily: '"Helvetica Neue LT Std Roman", sans-serif',
      color: '#181818',
      textAlign: 'center',
    },
    calle:{
      width: '100%',
      marginRight: 0,
      flex: 1,
    },
    numeroExterior:{
      width: '100%',
      flex: 1,
    },
    numeroInterior:{
      width: '100%',
      marginRight: 0,
      flex: 1,
    },
    colonia:{
//    width: 'auto',
      width: '100%',
      marginRight: 0,
      flex: 1,
    },
    municipio:{
      width: '100%',
      marginRight: 0,
      flex: 1,
    },
    estado:{
      width: '100%',
      marginRight: 0,
      flex: 1,
    },
  }, {
    iconItemGroupStep: {
      display: 'none',
    },
    itemGroupStep: {
      width: '100%',
      flexWrap: 'wrap',
    },
    containterSteps: {
      width: '100%',
    },
    inputExtraLarge:{
      width: '100%',
    },
    inputGroup:{
      width: 150,
    },
//  groupColonia: {
//    width: '100%',
//  },
//  colonia:{
//    width: '100%',
//  },
    groupLada:{
    },
    lada:{
      minWidth: 330,
      marginBottom: 30,
    },
    telefono:{
      minWidth: 210,
      flex: 0,
      width: 'auto',
    },
    inputExtraSmall:{
      width: 100,
    },
    iconCard:{
      width: 51,
    },
    containerButtons:{
      width: '100%',
      justifyContent: 'space-between',
    },
    buttons:{
      width: 135,
    },
    buttonDownload: {
      width: 140,
    },
    inputComponent:{
      width: '100%',
    },
    pressableQuestion:{
      marginBottom: -26,
    },
    modal:{
    },
    imageHelp:{
      width: 340,
      height: 240,
    },
    columnReverse:{
      flexDirection: 'column-reverse',
    },
    errorPersonales: {
      flexWrap: 'wrap',
      height: 'auto',
      paddingTop: 15,
      paddingBottom: 15,
      ...Platform.select({
        android: {
          width: '100%',
        },
      }),
    },
    errorPersonalesText:{
      textAlign: 'center',
      marginTop: 5,
      marginLeft: 10,
      marginRight: 10,
    },
  });
  return style(layout);
};
